import React, { useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { DsButton, DsForm, DsIcon, DsInputString } from '@tokenyico/design-system/dist/reactJS';
import { vWalletAddress } from '@tokenyico/design-system';

import { CentralizedExchangeService } from 'services';

import './CentralizedExchange.less';

const AddDepositWalletDialog = ({
  cex,
  onCloseModal,
  state: { selectedToken, setError, setSuccess },
}) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [wallet, setWallet] = useState('');
  const walletRef = useRef(null);

  const handleCloseModal = () => {
    setWallet('');
    onCloseModal();
  };

  //reset form on close
  useEffect(() => {
    if (!cex) {
      setWallet('');
      walletRef.current.hideError();
    }
  }, [onCloseModal]);

  const onSubmit = async () => {
    setIsSubmitting(true);

    try {
      await CentralizedExchangeService.addDepositWallet({
        cexId: cex?.id,
        tokenId: selectedToken.id,
        walletAddress: wallet,
      });
      setSuccess(t('shared.depositWalletSuccess'), 10000);
      handleCloseModal();
    } catch (e) {
      setError(e);
    }

    setIsSubmitting(false);
  };

  return (
    <DsForm className="add-wallet" onSubmit={onSubmit}>
      <div className="_grid" style={{ maxWidth: '50rem' }}>
        <div className="_col(12) _flex:justify(space-between) _flex:center">
          <h3 className="h3 _flex:center">
            <DsIcon size="24px" name="wallet" />
            {t('shared.addDepositWallet')}
          </h3>
          <img height="32px" src={cex?.logo || selectedToken.image} />
        </div>

        <div className="_col(12)">
          <DsInputString
            name="wallet"
            type="text"
            label={t('shared.depositWalletAddress')}
            value={wallet}
            onDsInput={({ detail }) => setWallet(detail)}
            validate={vWalletAddress}
            helperText={t('shared.depositWalletHelpText', { url: cex?.url ?? '' })}
            ref={walletRef}
          />
        </div>

        <div className="add-wallet__cta">
          <DsButton
            version="primary"
            label={t('shared.add')}
            icon="checkmark"
            type="submit"
            isLoading={isSubmitting}
            className="_m:left(2)"
          />
        </div>
      </div>
    </DsForm>
  );
};

export default AddDepositWalletDialog;
